export default "__VITE_ASSET__DCNHQdDL__"